import { InjectionToken } from '@angular/core';
import { I18nKeyTypeMap } from './i18n-key-type-map';

export const I18N_KEY_TYPE_MAP = new InjectionToken<I18nKeyTypeMap>('I18N_KEY_TYPE_MAP');
